import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
const classNames = require('classnames');
import { RouteComponentProps, Link } from 'react-router';
import { default as Slider, Settings } from 'react-slick';
import { PortalOneColumnLayout } from 'components/PortalStructure';
import { IStore } from 'redux/IStore';
import {
	getProductCardByCodeAndShopId,
	followShop,
	unfollowShop,
	setIsMyShop,
	getShopFollowButtonData,
	resetData,
	getProductCardSuccess,
	addItemToShoppingBasket,
	getProductVariations,
	getProductCard,
} from 'modules/product/productcard';
import { IProductCardData, IProductCardDataAction, IProductCard } from 'models/product/productcard';
import { LikeButton, WhiteButton, ErrorSummary, BlackButton, FollowButton } from 'components';
import { Helmet } from 'react-helmet';
import { IImageData, ICategoryDomainValue, IProductAttributes } from 'models/common';
import { Spinner } from 'components';
import { IUserPreferences } from 'models/user/userpreferences';
import * as c from 'models/constants';
import { YouMayAlsoLikeProducts, ErrorPage, AuthConsumer } from 'containers';
import { IUserLanguage } from 'models/user/userlanguage';
import { truncateText, formatCurrency, setProductPictureUrl, imgSrcAttributes, thumbUrl } from 'helpers/common';
import { PinterestShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';
import { Wishlists } from 'redux/modules/user/wishlists';
import { Likes } from 'redux/modules/user/likes';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { EditorChoiceNodeType } from 'models/enums/nodetype/editorchoicenodetype';
import { EditorChoices } from 'redux/modules/user/editorChoices';
import { ICartAction } from 'models/cart/cart';
import { getCategoryDomainValues } from 'redux/modules/domainvalues';
import { IDomainValuesAction } from 'models/domainvalues/domainvalues';
import { PortalSelectMenu } from 'components/FormControls';
import { StarsRating } from 'components/Common/StarsRating';
import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemPanel,
	AccordionItemButton,
} from 'react-accessible-accordion';
import { Magnifier, MOUSE_ACTIVATION, TOUCH_ACTIVATION } from 'react-image-magnifiers';
const { asyncConnect } = require('redux-connect');
require('./style.css');

interface IProps extends RouteComponentProps<IParams, {}> {
	productCardData?: IProductCardData;
	userLanguage?: IUserLanguage;
	baseUrlClient?: string;
	userPreferences: IUserPreferences;
	categories?: ICategoryDomainValue[];

	/* function props */
	getProductCardByCodeAndShopId?: (code: string, shopId: string) => IProductCardDataAction;
	getProductCard?: (id: string) => IProductCardDataAction;
	setIsMyShop: (isMyShop: boolean) => IProductCardDataAction;
	getShopFollowButtonData: () => IProductCardDataAction;
	getProductCardSuccess: (productCard: IProductCard) => IProductCardDataAction;
	addItemToShoppingBasket: (id: string) => ICartAction;
	t?: (key: string, options?: any) => string;
	followShop?: (id: string) => IProductCardDataAction;
	unfollowShop?: (id: string) => IProductCardDataAction;
	resetData?: () => IProductCardDataAction;
	getProductVariations: (variantParentId: string) => IProductCardDataAction;
	getCategoryDomainValues?: () => IDomainValuesAction;
	dispatch: any;
}

interface IState {
	truncateProductDescription: boolean;
	socialLinksVisible: boolean;
	activeSlides: number[];
}

interface IParams {
	code: string;
}

export const PreviousSlide = (props) => (
	<a onClick={props.onClick} className="slider-arrow  left" type="button">
		<img src={require('containers/Html/icons/slider-arrow.svg')} />
	</a>
);

export const NextSlide = (props) => (
	<a onClick={props.onClick} className="slider-arrow right" type="button">
		<img src={require('containers/Html/icons/slider-arrow.svg')} />
	</a>
);

@asyncConnect([
	{
		promise: ({ store: { dispatch, getState }, params, location }) => {
			const productCardData = (getState as () => IStore)().productCard;
			if (
				!params.code ||
				!location.query.shopId ||
				(productCardData &&
					productCardData.productCard &&
					productCardData.productCard.code === params.code &&
					productCardData.productCard.shopId === location.query.shopId)
			) {
				return;
			}
			const promises: Array<Promise<any>> = [
				dispatch(getProductCardByCodeAndShopId(params.code, location.query.shopId)),
			];
			if (!(getState as () => IStore)().domainValues.categories) {
				promises.push(dispatch(getCategoryDomainValues()));
			}
			return Promise.all(promises);
		},
	},
])
@connect(
	(state: IStore) => ({
		productCardData: state.productCard,
		userLanguage: state.userLanguage,
		baseUrlClient: state.fetchDefault.baseUrlClient,
		userPreferences: state.userPreferences,
		categories: state.domainValues.categories,
	}),
	(dispatch) => ({
		getProductCardByCodeAndShopId: (code: string, shopId: string) =>
			dispatch(getProductCardByCodeAndShopId(code, shopId)),
		getProductCard: (id: string) => dispatch(getProductCard(id)),
		followShop: (id: string) => dispatch(followShop(id)),
		unfollowShop: (id: string) => dispatch(unfollowShop(id)),
		setIsMyShop: (isMyShop: boolean) => dispatch(setIsMyShop(isMyShop)),
		getShopFollowButtonData: () => dispatch(getShopFollowButtonData()),
		getProductCardSuccess: (productCard: IProductCard) => dispatch(getProductCardSuccess(productCard)),
		addItemToShoppingBasket: (id: string) => dispatch(addItemToShoppingBasket(id)),
		resetData: () => dispatch(resetData()),
		getProductVariations: (variantParentId: string) => dispatch(getProductVariations(variantParentId)),
		getCategoryDomainValues: () => dispatch(getCategoryDomainValues()),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ProductCard extends React.Component<IProps, IState> {
	private wishlists: Wishlists = null;
	private likes: Likes = null;
	private editorChioces: EditorChoices = null;

	constructor(props) {
		super(props);

		this.state = {
			truncateProductDescription: true,
			socialLinksVisible: false,
			activeSlides: [0],
		};

		this.wishlists = new Wishlists(WishlistNodeType.ProductCard);
		this.likes = new Likes(LikeNodeType.ProductCard);
		this.editorChioces = new EditorChoices(EditorChoiceNodeType.ProductCard);

		this.followShop = this.followShop.bind(this);
		this.unfollowShop = this.unfollowShop.bind(this);
		this.likeItem = this.likeItem.bind(this);
		this.unlikeItem = this.unlikeItem.bind(this);
		this.renderWishlistButton = this.renderWishlistButton.bind(this);
		this.generateFilterByAttribute = this.generateFilterByAttribute.bind(this);
		this.onAddToBagClick = this.onAddToBagClick.bind(this);
		this.truncateProductDescription = this.truncateProductDescription.bind(this);
	}

	public componentDidMount() {
		if (
			(!this.props.productCardData.productCard && this.props.params.code) ||
			(this.props.productCardData.productCard &&
				this.props.params.code &&
				this.props.params.code !== this.props.productCardData.productCard.code)
		) {
			this.props.getProductCardByCodeAndShopId(this.props.params.code, this.props.location.query.shopId);
		}

		this.props.getCategoryDomainValues();

		if (this.props.productCardData.productCard) {
			if (this.props.productCardData.productCard.variantParentId !== null) {
				this.props.getProductVariations(this.props.productCardData.productCard.variantParentId);
			}
		}
	}

	public componentDidUpdate(prevProps: IProps) {
		if (!prevProps.userPreferences.id && this.props.userPreferences.id) {
			if (this.props.productCardData.productCard) {
				this.props.dispatch(this.likes.getLikedItems());
				this.props.dispatch(this.wishlists.getWishlistedItems());

				if (this.props.productCardData.productCard.shopOwnerId === this.props.userPreferences.id) {
					this.props.setIsMyShop(true);
				} else {
					this.props.getShopFollowButtonData();
				}
			}
		}

		if (
			(this.props.productCardData.productCard !== null &&
				prevProps.productCardData.productCard === null &&
				this.props.productCardData.productCard.variantParentId !== null) ||
			(this.props.productCardData.productCard !== null &&
				prevProps.productCardData.productCard !== null &&
				this.props.productCardData.productCard.variantParentId !==
					prevProps.productCardData.productCard.variantParentId &&
				this.props.productCardData.productCard.variantParentId !== null)
		) {
			this.props.getProductVariations(this.props.productCardData.productCard.variantParentId);
		}

		if (prevProps.params.code !== this.props.params.code) {
			this.props.getProductCardByCodeAndShopId(this.props.params.code, this.props.location.query.shopId);
		}
	}

	public componentWillUnmount() {
		this.props.resetData();
	}

	private followShop() {
		const shopId = this.props.productCardData.productCard.shopId;
		this.props.followShop(shopId);
	}

	private unfollowShop() {
		const shopId = this.props.productCardData.productCard.shopId;
		this.props.unfollowShop(shopId);
	}

	private likeItem(isAuthenticated: any, signinRedirect: () => void) {
		if (isAuthenticated()) {
			this.props.dispatch(this.likes.likeItem(this.props.productCardData.productCard.id));
		} else {
			signinRedirect();
		}
	}

	private unlikeItem(isAuthenticated: any, signinRedirect: () => void) {
		if (isAuthenticated()) {
			this.props.dispatch(this.likes.unlikeItem(this.props.productCardData.productCard.id));
		} else {
			signinRedirect();
		}
	}

	private editorChoice(signinRedirect: () => void) {
		if (this.props.userPreferences.isAdministrator || this.props.userPreferences.isEditor) {
			this.props.dispatch(
				this.editorChioces.editorChoice(
					this.props.productCardData.productCard.id,
					this.props.productCardData.productCard.entityId,
				),
			);
		} else {
			signinRedirect();
		}
	}

	private editorChoiceRemove(signinRedirect: () => void) {
		if (this.props.userPreferences.isAdministrator || this.props.userPreferences.isEditor) {
			this.props.dispatch(
				this.editorChioces.editorChoiceRemove(
					this.props.productCardData.productCard.id,
					this.props.productCardData.productCard.entityId,
				),
			);
		} else {
			signinRedirect();
		}
	}

	private wishlist(isAuthenticated: any, signinRedirect: () => void) {
		if (isAuthenticated()) {
			this.props.dispatch(this.wishlists.wishlist(this.props.productCardData.productCard.id));
		} else {
			signinRedirect();
		}
	}

	private unwish(isAuthenticated: any, signinRedirect: () => void) {
		if (isAuthenticated()) {
			this.props.dispatch(this.wishlists.unwish(this.props.productCardData.productCard.id));
		} else {
			signinRedirect();
		}
	}

	private renderWishlistButton(
		isAuthenticated: any,
		signinRedirect: () => void,
		unitsInStock: number,
		isWishlisted?: boolean,
	): JSX.Element {
		const { t } = this.props;
		let wishlistBtnContent: JSX.Element = null;
		if (isWishlisted === undefined || isWishlisted === null) {
			wishlistBtnContent = (
				<div style={{ textAlign: 'center' }}>
					<Spinner />
				</div>
			);
		} else if (!isWishlisted) {
			wishlistBtnContent = (
				<WhiteButton
					onClick={() => {
						this.wishlist(isAuthenticated, signinRedirect);
					}}
				>
					{t(unitsInStock > 0 ? 'BSPortal_Common_AddToWishlist' : 'Product_ProductCard_Button_NotifyWhenAvailable')}
				</WhiteButton>
			);
		} else {
			wishlistBtnContent = (
				<WhiteButton
					onClick={() => {
						this.unwish(isAuthenticated, signinRedirect);
					}}
				>
					{t('BSPortal_Common_RemoveFromWishlist')}
				</WhiteButton>
			);
		}
		return wishlistBtnContent;
	}

	private renderEditorChoiceButton(signinRedirect: () => void, editorChoice: boolean): JSX.Element {
		const { t } = this.props;
		const { isAdministrator, isEditor } = this.props.userPreferences;
		let editorChoiceBtnContent: JSX.Element = null;
		if (isAdministrator || isEditor) {
			if (editorChoice) {
				editorChoiceBtnContent = (
					<WhiteButton
						onClick={() => {
							this.editorChoiceRemove(signinRedirect);
						}}
					>
						{t('BSPortal_Common_EditorChoiceRemove')}
					</WhiteButton>
				);
			} else {
				editorChoiceBtnContent = (
					<WhiteButton
						onClick={() => {
							this.editorChoice(signinRedirect);
						}}
					>
						{t('BSPortal_Common_EditorChoice')}
					</WhiteButton>
				);
			}
		}
		return editorChoiceBtnContent;
	}

	private generateFilterByAttribute<K extends keyof IProductAttributes>(
		key: K,
		prefiltered: Array<keyof IProductAttributes>,
	) {
		return (value: IProductAttributes[K]) => {
			if (value === undefined || value === null) {
				return;
			}
			const products = this.props.productCardData.productVariations.filter((x) => {
				for (const prefilter of prefiltered) {
					const expected = this.props.productCardData.productCard.attributes[prefilter];
					const val = x.attributes[prefilter];
					if (expected !== null && expected !== undefined && val !== null && val !== undefined && val !== expected) {
						return false;
					}
				}
				return x.attributes[key] === value;
			});
			if (products.length) {
				const firstProduct = products[0];
				this.props.getProductCard(firstProduct.id);
			} else {
				console.error('Cannot find a matching variation');
			}
		};
	}

	private onAddToBagClick(_, signinRedirect) {
		if (this.props.userPreferences.id !== null) {
			const externalLink: string = this.props.productCardData.productCard.externalLink;
			if (externalLink) {
				window.open(externalLink, '_blank');
			} else {
				const id: string = this.props.productCardData.productCard.id;
				this.props.addItemToShoppingBasket(id);
			}
		} else {
			signinRedirect();
		}
	}

	private truncateProductDescription(e: React.SyntheticEvent, truncateProductDescription: boolean) {
		e.preventDefault();
		this.setState({ truncateProductDescription });
	}

	private setProductImages(images: IImageData[]): JSX.Element[] {
		const imagesElements: JSX.Element[] = [];
		const activeSlides = this.state.activeSlides;
		if (images && images.length > 0) {
			images.map((image: IImageData, index) => {
				imagesElements.push(
					<div key={image.id}>
						<Magnifier
							imageSrc={activeSlides.indexOf(index) === -1 ? thumbUrl(image.href) : image.href}
							largeImageSrc={image.href}
							mouseActivation={MOUSE_ACTIVATION.SINGLE_CLICK}
							touchActivation={TOUCH_ACTIVATION.SINGLE_TAP}
							dragToMove={false}
						/>
					</div>,
				);
			});
		} else {
			imagesElements.push(
				<div key={'productCard_defaultProductImage'}>
					<img className="image" {...setProductPictureUrl(null)} />
				</div>,
			);
		}
		return imagesElements;
	}

	// private handleSizeGuideClick(e: any) {
	//   e.preventDefault();
	//   window.open('/sizeguide', '_blank');
	// }

	private getAttributes() {
		const { t } = this.props;
		const { variantParentId, attributes } = this.props.productCardData.productCard;
		const { productVariations } = this.props.productCardData;

		interface ISetting {
			key: keyof IProductAttributes;
			prefix: string;
			stock?: true;
			placeholder?: string;
		}

		const settings: {
			[key in 'color' | 'size' | 'format' | 'formulation' | 'treatment' | 'skin' | 'speciality']: ISetting;
		} = {
			color: {
				key: 'ColorKey',
				prefix: 'DV_Colors_',
				placeholder: t('Product_ProductCard_Label_Color'),
			},
			size: {
				key: 'SizeKey',
				prefix: 'DV_Sizes_',
				stock: true,
				placeholder: t('Product_ProductCard_Label_Size'),
			},
			format: {
				key: 'FormatKey',
				prefix: 'DV_Formats_',
				placeholder: t('Shop_ManageShop_Products_CreateProduct_Label_Format'),
			},
			formulation: {
				key: 'FormulationKey',
				prefix: 'DV_Formulations_',
				placeholder: t('Shop_ManageShop_Products_CreateProduct_Label_Formulation'),
			},
			treatment: {
				key: 'TreatmentKey',
				prefix: 'DV_Treatments_',
				placeholder: t('Shop_ManageShop_Products_CreateProduct_Label_Treatment'),
			},
			skin: {
				key: 'SkinTypeKey',
				prefix: 'DV_SkinTypes_',
				placeholder: t('Shop_ManageShop_Products_CreateProduct_Label_SkinType'),
			},
			speciality: {
				key: 'SpecialityKey',
				prefix: 'DV_Specialities_',
				placeholder: t('Shop_ManageShop_Products_CreateProduct_Label_Speciality'),
			},
		};

		const elements: JSX.Element[] = [];
		const names = Object.keys(settings);
		const prefiltered: Array<keyof IProductAttributes> = [];
		for (const name of names) {
			const setting = settings[name];
			const options: any[] = [];
			const optionFromItem = (item: IProductCard) => {
				if (item.attributes[setting.key] === undefined || item.attributes[setting.key] === null) {
					return;
				}
				let text = item.attributes[setting.key] ? t(setting.prefix + item.attributes[setting.key]) : '';
				if (setting.stock) {
					if (item.unitsInStock === 0) {
						text = t('Product_ProductCard_SizeSoldOut', { size: text });
					} else if (item.unitsInStock > 0 && item.unitsInStock < 5) {
						text = t('Product_ProductCard_SizeLowStock', { size: text });
					}
				}

				const option = {
					key: item.attributes[setting.key],
					value: text,
				};

				if (!options.find((x) => x.key === option.key)) {
					options.push(option);
				}
			};
			if (variantParentId !== null) {
				productVariations
					.filter((variation) => {
						for (const prefilter of prefiltered) {
							const expected = this.props.productCardData.productCard.attributes[prefilter];
							const val = variation.attributes[prefilter];
							if (
								expected !== null &&
								expected !== undefined &&
								val !== null &&
								val !== undefined &&
								val !== expected
							) {
								return false;
							}
						}
						return true;
					})
					.forEach(optionFromItem);
			} else {
				optionFromItem(this.props.productCardData.productCard);
			}

			if (options.length) {
				const prevPrefiltered = prefiltered.slice(0); //copy
				prefiltered.push(setting.key);
				const inputId = 'product' + name.slice(0, 1).toUpperCase() + name.slice(1) + 'Dropdown';
				const input: object = {
					id: inputId,
					onChange: this.generateFilterByAttribute(setting.key, prevPrefiltered),
					value: attributes[setting.key],
					name: inputId,
				};
				const element = (
					<PortalSelectMenu
						key={name}
						isRequired={true}
						isDisabled={options.length <= 1}
						input={input}
						items={options}
						label={setting.placeholder}
					/>
				);
				elements.push(element);
			}
		}
		return elements;
	}

	public render() {
		// we also have error summary component (for add to bag action), so if 422 let error pass to error summary
		if (this.props.productCardData.error && this.props.productCardData.message.status !== 422) {
			return <ErrorPage {...this.props} message={this.props.productCardData.message} />;
		}

		if (!this.props.productCardData.productCard) {
			return null;
		}

		const { t } = this.props;
		const { truncateProductDescription } = this.state;
		const {
			images,
			picture,
			id,
			name,
			price,
			originalPrice,
			onSale,
			sku,
			unitsInStock,
			description,
			isLiked,
			shopCode,
			shopDescription,
			shopFollowersCount,
			shopLocation,
			shopName,
			shopCoverPicture,
			shopCurrencyKey,
			metatagDescription,
			metatagKeywords,
			metatagTitle,
			code,
			shopId,
			isWishlisted,
			likesCount,
			shopAverageRating,
			shopVotes,
			shortDescription,
			composition,
			delivery,
			editorChoice,
		} = this.props.productCardData.productCard;
		const { isMyShop, shopIsFollowed, error, message } = this.props.productCardData;

		let shopPictureToDisplay = require('containers/Html/images/defaultShop.svg');
		if (shopCoverPicture && shopCoverPicture.length > 0) {
			shopPictureToDisplay = thumbUrl(shopCoverPicture);
		}

		const settings: Settings = {
			customPaging: (i) => {
				return (
					<a>
						<img {...imgSrcAttributes(images[i].href)} />
					</a>
				);
			},
			dots: true,
			lazyLoad: true,
			dotsClass: 'slick-dots slick-thumb',
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,

			prevArrow: <PreviousSlide />,
			nextArrow: <NextSlide />,
			beforeChange: (_, next) => {
				if (this.state.activeSlides.indexOf(next) === -1) {
					this.setState({ activeSlides: [...this.state.activeSlides, next] });
				}
			},
		};

		const productUrl = this.props.baseUrlClient + '/products/' + code + '?shopId=' + shopId;

		const errorSummaryProps = {
			error,
			message,
		};

		const options = this.getAttributes();

		return (
			<AuthConsumer>
				{({ isAuthenticated, signinRedirect }) => {
					return (
						<PortalOneColumnLayout>
							<div className="productCardErrorSummary">
								<ErrorSummary {...errorSummaryProps} />
							</div>
							<div className="productCardContainer">
								<div className="overview">
									<div className="leftImageSlider">
										<div className="imageSlider">
											<Slider {...settings}>{this.setProductImages(images)}</Slider>
										</div>
									</div>
									<div className="rightContent">
										<div className="shopLikeInline">
											<div className="shopName">
												<Link to={`/shop/${shopCode}`}>{shopName}</Link>
											</div>
											<LikeButton
												isLiked={isLiked}
												likeItem={this.likeItem}
												unlikeItem={this.unlikeItem}
												isAuthenticated={isAuthenticated}
												signinRedirect={signinRedirect}
												likesCount={likesCount}
											/>
										</div>
										<div className="name">
											<h2>{name}</h2>
										</div>
										<div className="description">
											<p>
												{truncateProductDescription ? truncateText(shortDescription, 230) : shortDescription}
												{shortDescription && shortDescription.length > 230 ? (
													truncateProductDescription ? (
														<a href="#" onClick={(e) => this.truncateProductDescription(e, false)}>
															{' '}
															{t('BSPortal_Common_ReadMore')}
														</a>
													) : (
														<a href="#" onClick={(e) => this.truncateProductDescription(e, true)}>
															{' '}
															{t('BSPortal_Common_ShowLess')}
														</a>
													)
												) : null}
											</p>
										</div>
										<div className="price">
											<p>
												{onSale ? (
													<span className="salePrice">{formatCurrency(shopCurrencyKey, originalPrice)}</span>
												) : null}
												<span className={classNames({ ['realPrice']: onSale })}>
													{formatCurrency(shopCurrencyKey, price)}
												</span>
											</p>
										</div>
										{options}
										{unitsInStock > 0 ? (
											<div className="addToCartBtn">
												<BlackButton
													type="button"
													onClick={(e) => this.onAddToBagClick(e, signinRedirect)}
													disabled={unitsInStock === 0}
												>
													{t('Product_ProductCard_Button_AddToBag')}
												</BlackButton>{' '}
											</div>
										) : null}
										<div className="buttonsInLine">
											<div className="wishlistBtn">{this.renderEditorChoiceButton(signinRedirect, editorChoice)}</div>
											<div className="wishlistBtn">
												{this.renderWishlistButton(isAuthenticated, signinRedirect, unitsInStock, isWishlisted)}
											</div>
											<div className="shareBtn">
												<div className={classNames('aroundButton', { ['openShare']: this.state.socialLinksVisible })}>
													<WhiteButton
														type="button"
														onClick={() => this.setState({ socialLinksVisible: !this.state.socialLinksVisible })}
													>
														Share
													</WhiteButton>
													<div className={classNames('socialIcons', { ['show']: this.state.socialLinksVisible })}>
														<FacebookShareButton url={productUrl}>Facebook</FacebookShareButton>
														<TwitterShareButton url={productUrl} title={this.props.productCardData.productCard.name}>
															Twitter
														</TwitterShareButton>
														<PinterestShareButton url={productUrl} media={'.'}>
															Pinterest
														</PinterestShareButton>
													</div>
												</div>
											</div>
										</div>
										<div className="silverLine">
											<span className="titleSmall">{t('Product_ProductCard_Label_ProductId')}</span>
											<span className="silverText"> {sku}</span>
										</div>
										<div className="productAccordion">
											<Accordion allowZeroExpanded={true}>
												{description && description.length > 0 ? (
													<AccordionItem key={1}>
														<AccordionItemHeading>
															<AccordionItemButton>{t('Product_ProductCard_Label_Details')}</AccordionItemButton>
														</AccordionItemHeading>
														<AccordionItemPanel>{description}</AccordionItemPanel>
													</AccordionItem>
												) : null}
												{composition && composition.length > 0 ? (
													<AccordionItem key={2}>
														<AccordionItemHeading>
															<AccordionItemButton>
																{t('Product_ProductCard_Label_MaterialAndCare')}
															</AccordionItemButton>
														</AccordionItemHeading>
														<AccordionItemPanel>{composition}</AccordionItemPanel>
													</AccordionItem>
												) : null}
												{delivery && delivery.length > 0 ? (
													<AccordionItem key={3}>
														<AccordionItemHeading>
															<AccordionItemButton>{t('Product_ProductCard_Label_ShippingInfo')}</AccordionItemButton>
														</AccordionItemHeading>
														<AccordionItemPanel>{delivery}</AccordionItemPanel>
													</AccordionItem>
												) : null}
											</Accordion>
										</div>
									</div>
								</div>
								<div className="shopCard">
									<div className="leftHeader">
										<p>SHOP INFO</p>
									</div>
									<div className="imageShop">
										<Link to={`/shop/${shopCode}`}>
											<div className="borderWrapperImage" style={{ backgroundImage: `url(${shopPictureToDisplay})` }} />
										</Link>
									</div>
									<div className="cardMiddleTxt">
										<FollowButton
											itemType={c.NODE_TYPE_SHOP}
											displayFollowerCount={true}
											isFollowing={shopIsFollowed}
											followerCount={shopFollowersCount}
											follow={this.followShop}
											unfollow={this.unfollowShop}
											isMyItem={isMyShop}
										/>
										<div className="shopName">
											<Link to={`/shop/${shopCode}`}>{shopName}</Link>
										</div>
										<div className="shopLocation">{shopLocation}</div>
										<div>
											<StarsRating editing={false} rating={shopAverageRating} votes={shopVotes} />
										</div>
										<div className="shopDescription">
											<p>{shopDescription}</p>
										</div>
									</div>
								</div>

								<div className="youMayAlsoLike">
									<YouMayAlsoLikeProducts id={id} location={this.props.location} />
								</div>
								<Helmet
									title={metatagTitle || name}
									link={[{ rel: 'canonical', href: productUrl }]}
									meta={[
										{ property: 'og:title', content: metatagTitle || name },
										{ property: 'og:image', content: picture },
										{ property: 'og:description', content: metatagDescription || description },
										{ property: 'og:url', content: productUrl },
										{ name: 'title', content: metatagTitle || name },
										{ name: 'description', content: metatagDescription || description },
										{ name: 'keywords', content: metatagKeywords },
									]}
								/>
							</div>
						</PortalOneColumnLayout>
					);
				}}
			</AuthConsumer>
		);
	}
}
export { ProductCard };
